<template>
    <div class="modal modal-todo modal-card-label fade" tabindex="-1" role="dialog" aria-labelledby="add-edit-card-label-modal" aria-hidden="true" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalTitle }}</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <form @submit.prevent="submitLabel">
                        <div class="form-group">
                            <label>Color</label>
                            <div ref="colorInput" class="color-input-wrapper" @click="toggleColorPicker">
                                <div ref="colorPicker" class="color-preview" :style="{ backgroundColor: selectedColor }"></div>
                            </div>
                            <div v-if="showColorPicker" ref="colorPicker" class="color-picker-wrapper mt-2">
                                <chrome-picker :value="selectedColor" @input="updateColor" />
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Label Name</label>
                            <input type="text" class="form-control" v-model="labelName" placeholder="Enter label name" />
                        </div>

                        <button type="submit" class="btn btn-submit btn-block mt-3 btn-primary">
                            {{ modalButtonText }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Chrome } from 'vue-color';

export default {
    name: 'AddEditCardLabelModal',
    components: {
        'chrome-picker': Chrome
    },
    data() {
        return {
            labelId: null,
            labelName: '',
            selectedColor: '#808080',
            showColorPicker: false,
            isEditMode: false,
            modalTitle: 'New Label',
            modalButtonText: 'Save'
        };
    },
    mounted() {
        document.body.appendChild(this.$el);
        document.addEventListener('mousedown', this.clickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.clickOutside);
    },
    methods: {
        openModal(label = null) {
            if (label) {
                this.isEditMode = true;
                this.labelId = label.id;
                this.labelName = label.name;
                this.selectedColor = label.color;
                this.modalTitle = 'Edit Label';
                this.modalButtonText = 'Update';
            } else {
                this.isEditMode = false;
                this.labelId = null;
                this.labelName = '';
                this.selectedColor = '#808080';
                this.modalTitle = 'New Label';
                this.modalButtonText = 'Save';
            }

            this.$nextTick(() => {
                $(this.$refs.modal).modal({
                    backdrop: 'static',
                    keyboard: false
                });
            });
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');
            this.resetForm();
        },
        resetForm() {
            this.labelId = null;
            this.labelName = '';
            this.selectedColor = '#808080';
            this.showColorPicker = false;
            this.isEditMode = false;
        },
        toggleColorPicker() {
            this.showColorPicker = !this.showColorPicker;
        },
        updateColor(color) {
            this.selectedColor = color.hex;
        },
        submitLabel() {
            this.$emit('save', {
                id: this.labelId,
                name: this.labelName,
                color: this.selectedColor
            });

            this.closeModal();
        },
        clickOutside(event) {
            // console.log(event)
            const input = this.$refs.colorInput;
            const picker = this.$refs.colorPicker;

            if (this.showColorPicker && input && !input.contains(event.target) && picker && !picker.contains(event.target)) {
                this.showColorPicker = false;
            }
        }
    }
};
</script>
